<div class="row exposures-table-comment-row">
  <div class="col-12" (clickOutside)="clearTaskRanges($event)">
    <div class="card-inner-main-div">
      <div class="d-flex justify-content-between pt-3">
        <span class="fs-14 text-semibold align-self-center">{{'Exposure Contributions' | translate}}</span>
        @if (!loadingAssessments && showNewTask) {
          <a class="ml-auto transparent-btn"
            (click)="openTaskDialog()"><i class="fa fa-plus"></i>{{'Create' | translate}}</a>
          }
        </div>
        <div class="custom-theme-table">
          <div class="table-responsive outer-bordered-table custom-scrollbar curved-section-shadow">
            @if (loadingAssessments) {
              <app-widget-loader></app-widget-loader>
            }
            @if (!loadingAssessments) {
              <table mat-table #exposureContributionsTable [dataSource]="taskAssignmentDataSource"
                multiTemplateDataRows class="table table-striped custom-scrollbar" matSort matSortDisableClear
                (matSortChange)="sortExposureContributions($event)">
                @for (column of taskAssignmentColumnsToDisplay; track trackByIndex(j); let j = $index) {
                  <ng-container matColumnDef="{{ column }}">
                    <ng-container>
                      @if (taskAssignmentColumnsToDisplayStr[j] != 'Location') {
                        <th style="width: 144px" mat-sort-header="{{taskAssignmentColumnsToDisplayStr[j]}}" mat-header-cell *matHeaderCellDef>
                          <span class="font-700">
                            {{taskAssignmentColumnsToDisplayStr[j] | translate}}
                          </span>
                        </th>
                      } @else {
                        <th mat-header-cell *matHeaderCellDef>
                          <span class="font-700">
                            {{taskAssignmentColumnsToDisplayStr[j] | translate}}
                          </span>
                        </th>
                      }
                      <td mat-cell *matCellDef="let element; let i = dataIndex" class="position-relative">
                        <div class="colored-vertical-div"
                                         [ngStyle]="{
                                             'background-color': j == 0 ? taskColor[element['taskName']] : 'transparent',
                                             'display': j == 0 ? 'block' : 'none'
                                         }">
                        </div>
                        @if (
                          column.includes('location') &&
                          element[column].length > 1
                          ) {
                          <span class="multiple-hover-popup link-cursor">MULTIPLE
                            <div class="multiple-popup">
                              <table style="width: 100%">
                                <tbody>
                                  <tr>
                                    <th>
                                      <div class="img-div" style="text-align: center;">
                                        <img src="assets/images/location.png" />
                                      </div>
                                      {{'location' | translate}}
                                    </th>
                                    <th>
                                                            <div class="img-div" style="
                                                                    text-align: center;
                                                                ">
                                        <img src="assets/images/Time-shift.png" />
                                      </div>
                                      {{'Time on Shift' | translate}}:
                                    </th>
                                    <th>
                                                            <div class="img-div" style="
                                                                    text-align: center;
                                                                ">
                                        <img src="assets/images/contribution.png" />
                                      </div>
                                      {{'Mass contribution' | translate}}
                                    </th>
                                  </tr>
                                  @for (
                                    location of element.locations; track trackByIndex($index)) {
                                    <tr>
                                      <td>
                                        {{
                                        location.locationName
                                        }}
                                      </td>
                                      <td>
                                        {{
                                        location.timeOnShiftPercent
                                        }}
                                      </td>
                                      <td>
                                        {{
                                        location.massContributionPercent
                                        }}
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          </span>
                        }
                        @if (
                          column.includes('location') &&
                          element[column].length == 1
                          ) {
                          <span class="multiple-hover-popup link-cursor">{{
                            element.locations[0].locationName
                          }}</span>
                        }
                        @if (
                          !column.includes('location') ||
                          !element[column].length
                          ) {
                          <span>
                            {{
                            element[column]
                            ? element[column]
                            : " - "
                            }}
                          </span>
                        }
                      </td>
                    </ng-container>
                  </ng-container>
                }
                <ng-container matColumnDef="timeOnTaskPercentage">
                  <th mat-sort-header="Time on Shift" mat-header-cell *matHeaderCellDef
                    style="width: 152px; text-align: right">
                    <span class="font-700"> {{'Time on Shift' | translate}} % </span>
                  </th>
                            <td mat-cell *matCellDef="let element; let i = dataIndex" style="{{
                                    selectedTaskName == element['taskName'] &&
                                    !taskRangeVisibility
                                        ? 'background: ' +
                                          taskSelectColor[element['taskName']] +
                                          ' !important;'
                                        : ''
                                }}">
                    <div class="percentage-txt-div w-100 exposure">
                      @if (element.timeOnShiftPercent > 0.0) {
                        <div class="percent-box-outer">
                                        <span class="percent-box sky-blue-bg" [style.width.%]="
                                                element.timeOnShiftPercentageNum
                                            "></span>
                        </div>
                      }
                      <span class="pl-2">{{
                        element.timeOnShiftPercent
                      }}</span>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="massContributionPercentage">
                  <th mat-sort-header="Mass Contribution" mat-header-cell *matHeaderCellDef
                    style="width: 191px; text-align: right">
                    <span class="font-700">
                      {{'Mass contribution' | translate}} %
                    </span>
                  </th>
                            <td mat-cell *matCellDef="let element; let i = dataIndex" style="{{
                                    selectedTaskName == element['taskName'] &&
                                    !taskRangeVisibility
                                        ? 'background: ' +
                                          taskSelectColor[element['taskName']] +
                                          ' !important;'
                                        : ''
                                }}">
                    <div class="percentage-txt-div w-100 exposure">
                      @if (
                        element.massContributionPercentage >
                        0.0
                        ) {
                        <div class="percent-box-outer">
                                        <span class="percent-box purple-bg" [style.width.%]="
                                                element.massContributionPercentageNum
                                            "></span>
                        </div>
                      }
                      <span class="pl-2">{{
                        element.massContributionPercentage
                      }}</span>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="ppeAssignments">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="font-700"> {{'PPE' | translate}} </span>
                  </th>
                            <td mat-cell *matCellDef="let element; let i = dataIndex" style="{{
                                    selectedTaskName == element['taskName'] &&
                                    !taskRangeVisibility
                                        ? 'background: ' +
                                          taskSelectColor[element['taskName']] +
                                          ' !important;'
                                        : ''
                                }}">
                    @if (element['ppe']?.length) {
                      <span class="table-down-arrow" (mouseenter)="showHidePPE(i, true)"
                        style="height: 50px; width: 50px">
                        <img src="assets/images/PPE.svg" (mouseenter)="showHidePPE(i, true)" />
                      </span>
                    }
                    @if (showPPE[i]) {
                      <div class="card-box-dd chart-filter p-0"
                        (mouseenter)="showHidePPE(i, true)" (mouseleave)="showHidePPE(i, false)">
                        @for (ppe of element['ppe']; track trackByIndex($index)) {
                          <div>
                            @if (ppe.ppeType == 0) {
                              <div class="ppe-info row no-gutters vertical-align-middle"
                                >
                                <div class="col-md-12 m-0">
                                  <div class="m-2">
                                    <img src="assets/images/mask.png" height="43" width="43" />
                                  </div>
                                  <div class="h6 font-700">
                                    {{ ppe.ppeName }}
                                  </div>
                                </div>
                              </div>
                            }
                            @if (ppe.ppeType == 1) {
                              <div class="ppe-info row no-gutters vertical-align-middle"
                                >
                                <div class="col-md-12 m-0">
                                  <div class="m-2">
                                    <img src="assets/images/hearing.png" height="43" width="43" />
                                  </div>
                                  <div class="h6 font-700">
                                    {{ ppe.ppeName }}
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }
                  </td>
                </ng-container>
                <ng-container matColumnDef="Actions">
                  <th mat-header-cell *matHeaderCellDef>
                    <span class="font-700"> {{'Actions' | translate}} </span>
                  </th>
                  <td mat-cell *matCellDef="let taskAssignment" class="action-cell">
                    @if (
                      taskAssignment.taskAssignments
                      .length === 1) {
                      <div class="action-btns d-flex align-items-center">
                        <span class="material-icons edit cursor-pointer material-grey-icon"
                        (click)="openTaskDialog(taskAssignment)">edit</span>
                        <span class="material-icons delete cursor-pointer material-grey-icon"
                        (click)="openTaskDeleteDialog(taskAssignment)">delete</span>
                      </div>
                    } @else {
                                    <span class="material-icons bar-cd multiple-tasks cursor-pointer" (click)="
                                            openMultipleTaskDialog(
                                                taskAssignment
                                            )
                                        ">filter_none</span>
                    }
                  </td>
                </ng-container>
                        <tr mat-header-row *matHeaderRowDef="
                                taskAssignmentColumnsToDisplayWithExpand
                            "></tr>
                        <tr mat-row [class.even-row]="even" *matRowDef="let row; let even = even;
                                let element;
                                columns: taskAssignmentColumnsToDisplayWithExpand
                            " class="exposure-element-row" [class.exposure-expanded-row]="
                                taskAssignmentExposureExpandedElement ===
                                element
                            " (click)="
                                showTaskRange(
                                    taskRangeVisibility,
                                    element.taskName
                                );
                                element?.locationAssignments?.length
                                    ? (taskAssignmentExposureExpandedElement =
                                          taskAssignmentExposureExpandedElement ===
                                          element
                                              ? null
                                              : element)
                                    : element
                            "></tr>
                <tr class="mat-row no-data" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="
                                    taskAssignmentColumnsToDisplayWithExpand.length
                                ">
                    {{ errorMessage }}
                  </td>
                </tr>
              </table>
            }
          </div>
        </div>
      </div>
    </div>
  </div>